
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('animate',{attrs:{"id":"check","xlink:href":"#rect1","attributeName":"height","attributeType":"XML","from":"0","to":"230.5","fill":"freeze","begin":"0ms","dur":"100ms"}}),_c('animate',{attrs:{"xlink:href":"#rect2","attributeName":"height","attributeType":"XML","from":"0","to":"401.94","fill":"freeze","begin":"check.end","dur":"150ms"}})]),_c('rect',{attrs:{"id":"rect1","fill":"#00e1eb","x":"260.99","y":"356.69","width":"34.72","height":"0","rx":"5.85","ry":"5.85","transform":"translate(-259.34 366.61) rotate(-48.38)"}}),_c('rect',{attrs:{"id":"rect2","fill":"#00e1eb","x":"456.08","y":"198.81","width":"34.72","height":"0","rx":"7.19","ry":"7.19","transform":"translate(561.89 1013.09) rotate(-138.38)"}})])
          )
        }
      }
    